module.exports = __webpack_public_path__ + "img/xavier-university-logo.32b269e8.png";